import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { TranslateModule } from '@ngx-translate/core';
import { ContextService } from 'app/core/services/context.service';
import { MenuDropdownItem } from 'app/shared/types/menu-dropdown-item';
import { ThemeService } from 'core/services/theme.service';
import { AvatarComponent } from '../../atoms';

@Component({
  selector: 'app-dropdown-menu',
  templateUrl: './dropdown-menu.component.html',
  styles: [],
  imports: [
    MatMenuModule,
    NgClass,
    NgFor,
    MatIcon,
    AvatarComponent,
    NgIf,
    ReactiveFormsModule,
    AsyncPipe,
    TranslateModule,
    MatRadioModule,
  ],
})
export class DropdownMenuComponent implements OnChanges {
  @Input() public items: MenuDropdownItem[] | null = [];
  @Input() public isExpanded = false;

  @Output() public itemChanged = new EventEmitter<void>();

  @ViewChildren('itemElements') public itemElements!: QueryList<ElementRef>;

  public selectedItem!: MenuDropdownItem;

  public searchControl = new FormControl('');
  public menuItemControl = new FormControl();

  public filteredItems: MenuDropdownItem[] = [];
  public showIcon = false;

  protected contextService = inject(ContextService);
  protected readonly themeService = inject(ThemeService);

  public avatarColors$ = this.themeService.avatarColors$;

  protected searchControlSubscription = this.searchControl.valueChanges.subscribe((value) => this.filterItems(value));

  public ngOnChanges(): void {
    if (!this.items) return;

    this.filteredItems = [...this.items];
    const clientId = this.contextService.clientId.getValue();

    if (this.items.length > 0) {
      this.selectedItem = this.items.find((item) => item.id === clientId) || this.items[0];
      this.menuItemControl.setValue(this.selectedItem.id);
    }
  }

  public filterItems(query: string | null): void {
    if (!this.items) return;
    const search = query?.toLowerCase() || '';
    this.filteredItems = this.items.filter(
      (item) =>
        item.label.toLowerCase().includes(search) || (item.subLabel && item.subLabel.toLowerCase().includes(search))
    );
  }

  public onMenuClosed(): void {
    if (!this.items) return;
    this.searchControl.setValue('');
    this.filteredItems = [...this.items];
  }

  public change(item: MenuDropdownItem): void {
    this.selectedItem = item;
    this.contextService.clientId.next(this.selectedItem.id);
    this.menuItemControl.setValue(this.selectedItem.id);
    this.itemChanged.emit();
  }
}
